import { type Board, type Library } from '@air/api/types';

export type CanMoveBoardToLibraryBoard = {
  library?: Pick<Library, 'id'>;
  parentId: Board['parentId'];
};

/**
 * Dropping a board onto a library makes it a top-level board of that library.
 * Nested boards already in this library are allowed so they can be promoted;
 * already top-level boards of this library are rejected as a no-op.
 */
export const canMoveBoardToLibrary = (
  board: CanMoveBoardToLibraryBoard | undefined,
  libraryId: Library['id'],
): boolean => {
  if (!board) {
    return false;
  }

  const isAlreadyTopLevelInThisLibrary = board.library?.id === libraryId && board.parentId === null;

  return !isAlreadyTopLevelInThisLibrary;
};
